import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE_AND_CONNECTED = gql`
    query devicesActiveAndConnected {
        devicesActiveAndConnected {
            id
            name
            ip
            port
        }
    }
`
const GET_WITH_PAGINATION = gql`
    query devicesWithPagination ($page: Int, $perPage: Int) {
        devicesWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                name
                ip
                port
                observation
                is_active
                status_text
                status_connection
                status_connection_text
                amount_max_users
                amount_max_attendance
                amount_attendance
                amount_users
            }
        }
    }
`
/**
 * Mutations
 */
 const CREATE = gql`
 mutation createDevice ($input: DeviceCreateInput!) {
    createDevice (input: $input) {
         id
         name
         is_active
     }
 }
`

const UPDATE = gql`
 mutation updateDevice ($id: ID!, $input: DeviceUpdateInput!) {
    updateDevice (id: $id, input: $input) {
         id
         name
         is_active
     }
 }
`

const DELETE = gql`
 mutation deleteDevice ($id: ID!) {
     deleteDevice (id: $id) {
         id
         name
         is_active
     }
 }
`

const CONNECT = gql`
    mutation connectDevice ($id: ID!) {
        connectDevice (id: $id) {
            success
            error
            msgError
        }
    }
`

const UPDATE_STATUS_CONNECTION = gql`
    mutation updateStatusConnectionDevice($id: ID!, $status: Int!) {
      updateStatusConnectionDevice(id: $id, status_connection: $status) {
        id
        name
        ip
        port
        status_connection
        status_connection_text
      }
    }
`

const UPDATE_INFO = gql`
    mutation updateInfoDevice($id: ID!, $input: UpdateInfoDeviceInput!) {
      updateInfoDevice(id: $id, input: $input) {
        id
        name
        ip
        port
        amount_attendance
        amount_users
      }
    }
`

export {
    ALL_ACTIVE_AND_CONNECTED,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE,
    CONNECT,
    UPDATE_STATUS_CONNECTION,
    UPDATE_INFO
}
